// Old booking links (ads, Google Business Profiles, older pages) still point
// at the Firebase host and tapestodigital.biz/booking/... They're sent on to
// the market's booking subdomain, query string kept (gclid, utm_*).
// GTM never loads on these hosts (public/index.html only knows the two
// subdomains), so nothing is tracked before the redirect.

const NEW_ORIGIN = {
  AU: "https://booking.tapestodigital.com.au",
  UK: "https://booking.tapestodigital.co.uk",
};

const FIREBASE_HOSTS = ["t2d-bookig.web.app", "t2d-bookig.firebaseapp.com"];
// Only /booking/... redirects there; staff portal pages stay
const BIZ_HOSTS = ["tapestodigital.biz", "www.tapestodigital.biz"];

// Fixed pages that a root-level /<slug> must not be mistaken for
const FIXED_PAGES = [
  "booking",
  "booking-confirmation",
  "tape-estimate",
  "photo-quote",
  "manage",
  "r",
  "privacy-policy",
  "terms-of-service",
  "quote",
];

// What an old URL should become: { slug } when the location's country has to
// be looked up, { url } when it's known already, or null to stay put.
export function oldHostTarget({ hostname, pathname, search = "" }) {
  const isFirebase = FIREBASE_HOSTS.includes(hostname);
  if (!isFirebase && !BIZ_HOSTS.includes(hostname)) return null;

  const parts = pathname.split("/").filter(Boolean).map(decodeURIComponent);
  if (parts[0] === "booking" && parts.length === 2) return { slug: parts[1] };
  if (!isFirebase) return null;
  if (!parts.length) return { url: `${NEW_ORIGIN.AU}/${search}` };
  if (parts.length === 1 && !FIXED_PAGES.includes(parts[0])) return { slug: parts[0] };
  return null;
}

export function newBookingUrl(countryCode, slug, search = "") {
  const origin = NEW_ORIGIN[countryCode];
  return origin ? `${origin}/booking/${encodeURIComponent(slug)}${search}` : null;
}

// Resolves true when the page is being replaced (don't start the app), false
// to carry on here — including when the lookup fails, so a customer is
// never left on a blank page.
export async function redirectFromOldHost(backendUrl, loc = window.location) {
  const target = oldHostTarget(loc);
  if (!target) return false;

  let url = target.url;
  if (!url) {
    try {
      const res = await fetch(
        `${backendUrl}/api/v1/data/locations/by-slug/${encodeURIComponent(target.slug)}`
      );
      if (!res.ok) return false;
      const location = await res.json();
      url = newBookingUrl(location.country_code, target.slug, loc.search);
    } catch (e) {
      return false;
    }
  }
  if (!url) return false;
  loc.replace(url);
  return true;
}
